export default __webpack_public_path__ + "static/media/template2.477eaf44.png";